import { Box, Center, Heading, Icon, Tooltip } from "@chakra-ui/react";
import { Info } from "lucide-react";
import { useSelector } from "react-redux";
import FilterForm from "../../../components/FilterForm";
import BranchArrivalRatesPerHourReport from "../../../components/branches/reports/realtime/BranchArrivalRatesPerHour";
import _ from "lodash";
import { Helmet } from "react-helmet";
import { getReportDescription } from "../../../store/helpers";
import Loader from "../../../components/loader";

const BranchArrivalRatesPerHour = ({
  showFilterForm = true,
  reportIndex = 1,
}) => {
  const { branches, branchId, organizationId, reportRange, workDay } =
    useSelector((state) => state.defaultReducer);
  let branchesClone = _.cloneDeep(branches);
  branchesClone = branchesClone
    .filter(
      (a) =>
        a.reportStatus != null &&
        Number(a.reportStatus) &&
        a.organizationId === organizationId
    )
    .filter((a) => !branchId.length || (branchId.length && a.id === branchId));
  const reportTitle = `Branch Arrival Rates Per Hour`;

  return (
    <Box>
      <Helmet>
        <title>{reportTitle}</title>
      </Helmet>
      {showFilterForm ? <FilterForm /> : <></>}
      <>
        <Heading fontSize="34px" color="#222" fontWeight="700">
          {reportTitle}
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              <Icon as={Info} w={5} h={5} ml={2} cursor="pointer" />
            </Tooltip.Trigger>
            <Tooltip.Positioner>
              <Tooltip.Content>
                {getReportDescription(reportRange).BranchArrivalRatesPerHour}
              </Tooltip.Content>
            </Tooltip.Positioner>
          </Tooltip.Root>
        </Heading>
        {_.isEmpty(workDay) ? (
          <Loader />
        ) : (
          <BranchArrivalRatesPerHourReport
            reportIndex={reportIndex}
            branches={branchesClone}
          />
        )}
      </>
    </Box>
  );
};

export default BranchArrivalRatesPerHour;
